class CascadeEngine {

    public static bind($context: JQuery<any>): void {

        const elements = $context.find(".js-cascade");

        elements.each((_, el) => {
            const $el = $(el);

            if ($el.data("cascade-bound")) return;
            $el.data("cascade-bound", true);

            const parentName = $el.data("cascade-depends");
            const dataKey = $el.data("cascade-datakey");

            const $parent = $context.find<HTMLInputElement>(`[name='${parentName}']`);

            $parent.on("change", () => {
                this.populate($el, $parent.val());
            });

            // initial hydration (edit mode)
            this.populate($el, $parent.val(), $el.val());
        });
    }

    private static populate($el: JQuery, parentValue: any, selectedValue?: any): void {

        const key = $el.data("cascade-datakey");
        const data = (window as any).CascadeData?.[key] as CascadeLookup[] || [];

        const parentId = parentValue ? parseInt(parentValue) : null;

        const filtered = data.filter((x: CascadeLookup) =>
            x.parentId === parentId
        );

        const $placeholder = $el.find("option").first().clone();

        $el.empty();

        if ($placeholder.length > 0) {
            $el.append($placeholder);
        }

        filtered.forEach((x: any) => {
            $el.append(new Option(x.name, x.id));
        });

        const currentValue = selectedValue ?? $el.val();

        if (currentValue !== undefined && currentValue !== null && currentValue !== "") {
            $el.val(currentValue);
        }

        $el.trigger("change");
    }
}